export enum DialogOverlay {
  DARK = 'dark',
  NONE = 'none'
}
